// src/pages/DepartmentAdminDashboard.js
import React from 'react';
import DashboardShell from '../components/dashboard/DashboardShell';
import DepartmentDashboardView from '../components/dashboard/departmentadmin/DepartmentDashboardView';
import { getUser } from '../utils/auth';

function DepartmentAdminDashboard() {
  const user = getUser();

  return (
    <DashboardShell title={`Welcome, ${user.name}`} subtitle="Department overview">
      <DepartmentDashboardView />
    </DashboardShell>
  );
}

export default DepartmentAdminDashboard;
